import { makeStyles, createStyles } from "@mui/styles";
import { Theme, darken } from "@mui/material/styles";

const modalStyles = makeStyles((theme: Theme) =>
    createStyles({
        popoverPaper: {
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "inherit",
            height: "100vh",
        },
        popoverWrapper: {
            background: theme.palette.background.blue,
            borderRadius: "8px",
            overflow: "hidden",
            width: 497,
        },
        popoverTitle: {
            display: "flex",
            alignItems: "center",
            backgroundColor: theme.palette.info.main,
            color: theme.palette.text.alt,
            fontWeight: 600,
            justifyContent: "space-between",
            padding: theme.spacing(1, 2),
        },
        popoverContent: {
            padding: theme.spacing(1, 2),
            color: theme.palette.neutrals.dark,
        },
        popoverBtnContainer: {
            display: "flex",
            justifyContent: "end",
            padding: theme.spacing(2),
        },
        errorLegend: {
            display: "flex",
            position: "absolute",
            top: "10px",
            padding: "5px",
            color: theme.palette.warning.main,
            zIndex: 10,
            alignItems: "center",
        },
        errorLegendBtn: {
            color: theme.palette.warning.main,
            zIndex: 10,
        },
        tooltipWrapper: {
            background: theme.palette.background.blue,
            borderRadius: "8px",
            overflow: "hidden",
            width: 497,
        },
        tooltipTitle: {
            display: "flex",
            alignItems: "center",
            fontWeight: 600,
            justifyContent: "space-between",
            padding: theme.spacing(1, 2),
            color: theme.palette.neutrals.dark,
        },
        infoIcon: {
            transform: "rotate(180deg)",
            cursor: "pointer !important",
            color: theme.palette.warning.main,
            zIndex: 10,
        },
    })
);

export default modalStyles;
